/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {

  $('.featured-product-list_grid.slider').each(function() {    
    var desktopSlidesToShow = parseInt($(this).attr('desktop_per_row'));
    var mobileSlidesToShow = parseInt($(this).attr('mobile_per_row'));    
    $(this).slick({
      dots: true,
      arrows: true,
      slidesToShow: desktopSlidesToShow,
      slidesToScroll: 1,
      prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.6944 22.5836C11.3664 23.0456 12.2484 23.1296 13.0044 22.8776C14.8944 22.1636 15.2304 19.6016 13.5504 18.4256C11.4504 16.9556 9.14037 15.7376 7.25037 14.0156C6.74637 13.5956 6.28437 13.1336 5.94837 12.5876C6.36837 12.0416 6.87237 11.5796 7.37637 11.1596C8.25837 10.3616 13.0884 6.24559 14.0544 5.61559C15.6084 4.56559 15.5664 2.29759 13.9704 1.33159C13.1304 0.827589 12.0384 0.869589 11.1984 1.45759C9.98037 2.29759 4.14237 7.16959 3.09237 8.26159C2.04237 9.31159 0.992369 10.5716 0.824369 11.9996C0.740369 12.8396 0.950369 13.7636 1.28637 14.5196C2.04237 16.0736 3.34437 17.3756 4.68837 18.4676C6.57837 20.0216 8.67837 21.2396 10.6944 22.5836Z" fill="#805AA6"/>
        </svg></button>`,
      nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.30539 22.5836C4.63339 23.0456 3.75139 23.1296 2.99539 22.8776C1.10539 22.1636 0.769387 19.6016 2.44939 18.4256C4.54939 16.9556 6.85939 15.7376 8.74939 14.0156C9.25339 13.5956 9.71539 13.1336 10.0514 12.5876C9.63139 12.0416 9.12739 11.5796 8.62339 11.1596C7.74139 10.3616 2.91139 6.24559 1.94539 5.61559C0.391387 4.56559 0.433387 2.29759 2.02939 1.33159C2.86939 0.827589 3.96139 0.869589 4.80139 1.45759C6.01939 2.29759 11.8574 7.16959 12.9074 8.26159C13.9574 9.31159 15.0074 10.5716 15.1754 11.9996C15.2594 12.8396 15.0494 13.7636 14.7134 14.5196C13.9574 16.0736 12.6554 17.3756 11.3114 18.4676C9.42139 20.0216 7.32139 21.2396 5.30539 22.5836Z" fill="#805AA6"/>
        </svg></button>`,
      infinite: true,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    });
  });
      
  $('.coll-list-slider-list').slick({
      dots: true,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.6944 22.5836C11.3664 23.0456 12.2484 23.1296 13.0044 22.8776C14.8944 22.1636 15.2304 19.6016 13.5504 18.4256C11.4504 16.9556 9.14037 15.7376 7.25037 14.0156C6.74637 13.5956 6.28437 13.1336 5.94837 12.5876C6.36837 12.0416 6.87237 11.5796 7.37637 11.1596C8.25837 10.3616 13.0884 6.24559 14.0544 5.61559C15.6084 4.56559 15.5664 2.29759 13.9704 1.33159C13.1304 0.827589 12.0384 0.869589 11.1984 1.45759C9.98037 2.29759 4.14237 7.16959 3.09237 8.26159C2.04237 9.31159 0.992369 10.5716 0.824369 11.9996C0.740369 12.8396 0.950369 13.7636 1.28637 14.5196C2.04237 16.0736 3.34437 17.3756 4.68837 18.4676C6.57837 20.0216 8.67837 21.2396 10.6944 22.5836Z" fill="#805AA6"/>
        </svg></button>`,
      nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.30539 22.5836C4.63339 23.0456 3.75139 23.1296 2.99539 22.8776C1.10539 22.1636 0.769387 19.6016 2.44939 18.4256C4.54939 16.9556 6.85939 15.7376 8.74939 14.0156C9.25339 13.5956 9.71539 13.1336 10.0514 12.5876C9.63139 12.0416 9.12739 11.5796 8.62339 11.1596C7.74139 10.3616 2.91139 6.24559 1.94539 5.61559C0.391387 4.56559 0.433387 2.29759 2.02939 1.33159C2.86939 0.827589 3.96139 0.869589 4.80139 1.45759C6.01939 2.29759 11.8574 7.16959 12.9074 8.26159C13.9574 9.31159 15.0074 10.5716 15.1754 11.9996C15.2594 12.8396 15.0494 13.7636 14.7134 14.5196C13.9574 16.0736 12.6554 17.3756 11.3114 18.4676C9.42139 20.0216 7.32139 21.2396 5.30539 22.5836Z" fill="#805AA6"/>
        </svg></button>`,
      infinite: true,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    })

    $('.testimonial-sec-list').slick({
      dots: true,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow:`<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.6944 22.5836C11.3664 23.0456 12.2484 23.1296 13.0044 22.8776C14.8944 22.1636 15.2304 19.6016 13.5504 18.4256C11.4504 16.9556 9.14037 15.7376 7.25037 14.0156C6.74637 13.5956 6.28437 13.1336 5.94837 12.5876C6.36837 12.0416 6.87237 11.5796 7.37637 11.1596C8.25837 10.3616 13.0884 6.24559 14.0544 5.61559C15.6084 4.56559 15.5664 2.29759 13.9704 1.33159C13.1304 0.827589 12.0384 0.869589 11.1984 1.45759C9.98037 2.29759 4.14237 7.16959 3.09237 8.26159C2.04237 9.31159 0.992369 10.5716 0.824369 11.9996C0.740369 12.8396 0.950369 13.7636 1.28637 14.5196C2.04237 16.0736 3.34437 17.3756 4.68837 18.4676C6.57837 20.0216 8.67837 21.2396 10.6944 22.5836Z" fill="#805AA6"/>
        </svg></button>`,
      nextArrow:`<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.30539 22.5836C4.63339 23.0456 3.75139 23.1296 2.99539 22.8776C1.10539 22.1636 0.769387 19.6016 2.44939 18.4256C4.54939 16.9556 6.85939 15.7376 8.74939 14.0156C9.25339 13.5956 9.71539 13.1336 10.0514 12.5876C9.63139 12.0416 9.12739 11.5796 8.62339 11.1596C7.74139 10.3616 2.91139 6.24559 1.94539 5.61559C0.391387 4.56559 0.433387 2.29759 2.02939 1.33159C2.86939 0.827589 3.96139 0.869589 4.80139 1.45759C6.01939 2.29759 11.8574 7.16959 12.9074 8.26159C13.9574 9.31159 15.0074 10.5716 15.1754 11.9996C15.2594 12.8396 15.0494 13.7636 14.7134 14.5196C13.9574 16.0736 12.6554 17.3756 11.3114 18.4676C9.42139 20.0216 7.32139 21.2396 5.30539 22.5836Z" fill="#805AA6"/>
        </svg></button>`,
      infinite: true,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    })

  // EXPECTED DELIVERY DATE
  // if (document.querySelector('.product-meta-pro-info')) {
  //  function getOrdinalSuffix(n) {
  //   const s = ["th", "st", "nd", "rd"];
  //   const v = n % 100;
  //   return n + (s[(v - 20) % 10] || s[v] || s[0]);
  //  }  
  // const today = new Date();
  // const start = new Date(today);
  // const end = new Date(today);
  // start.setDate(today.getDate() + 4); // start date (e.g. 4 days from now)
  // end.setDate(today.getDate() + 6);   // end date (e.g. 6 days from now)
  // const startDay = getOrdinalSuffix(start.getDate());
  // const endDay = getOrdinalSuffix(end.getDate());
  // const month = start.toLocaleString("default", { month: "long" });
  // document.getElementById("order-delivery-range").textContent = `${startDay} – ${endDay} ${month}`;
  // }

  // DROPDOWN
  var firstTitle = $(".product-form__dropdown-title").first();
  firstTitle.addClass("active");
  firstTitle.next(".product-form__dropdown-content").slideDown();
  $('body').on('click','.product-form__dropdown-title', function(){
    var activeTitle = $(this);
    activeTitle.toggleClass('active');
    var currentDropdown = activeTitle.next('.product-form__dropdown-content');
    $('.product-form__dropdown-title').not(activeTitle).removeClass('active');
    $('.product-form__dropdown-content').not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });

  // FOOTER DROPDOWN
  if (window.matchMedia("(max-width: 740px)").matches) {
  $('body').on('click','.footer-item-link-title', function(){
    var activeTitle = $(this);
    activeTitle.toggleClass('active');
    var currentDropdown = activeTitle.next('.footer__item-content');
    $('.footer-item-link-title').not(activeTitle).removeClass('active');
    $('.footer__item-content').not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });
  }


  const header = document.querySelector('.store-header-wrapper');
  if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-heightt', `${headerHeight}px`);
  }
  
});